import { TenantEntity } from '../TenantEntity'

export class QuotationAirDetail extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'QuotationAirDetail'
  }

  get level() {
    return this._data.level
  }
  set level(level) {
    this._data.level = level || 0
  }
  get flight() {
    return this._data.flight
  }
  set flight(flight) {
    this._data.flight = flight
  }
  get aircraft() {
    return this._data.aircraft
  }
  set aircraft(aircraft) {
    this._data.aircraft = aircraft
  }
  get pol() {
    return this._data.pol
  }
  set pol(pol) {
    this._data.pol = pol
  }
  get pod() {
    return this._data.pod
  }
  set pod(pod) {
    this._data.pod = pod
  }
  get via() {
    return this._data.via
  }
  set via(via) {
    this._data.via = via
  }
  get minCharge() {
    return this._data.minCharge
  }
  set minCharge(minCharge) {
    this._data.minCharge = minCharge || 0
  }
  get step() {
    return this._data.step
  }
  set step(step) {
    this._data.step = step || 0
  }
  get fsc() {
    return this._data.fsc
  }
  set fsc(fsc) {
    this._data.fsc = fsc || 0
  }
  get ssc() {
    return this._data.ssc
  }
  set ssc(ssc) {
    this._data.ssc = ssc || 0
  }
  get p45() {
    return this._data.p45
  }
  set p45(p45) {
    this._data.p45 = p45 || 0
  }
  get p100() {
    return this._data.p100
  }
  set p100(p100) {
    this._data.p100 = p100 || 0
  }
  get p300() {
    return this._data.p300
  }
  set p300(p300) {
    this._data.p300 = p300 || 0
  }
  get p500() {
    return this._data.p500
  }
  set p500(p500) {
    this._data.p500 = p500 || 0
  }
  get p1000() {
    return this._data.p1000
  }
  set p1000(p1000) {
    this._data.p1000 = p1000 || 0
  }
  get carrier() {
    return this._data.carrier
  }
  set carrier(carrier) {
    this._data.carrier = carrier || 0
  }
  get agent() {
    return this._data.agent
  }
  set agent(agent) {
    this._data.agent = agent
  }
  get frequency1() {
    return this._data.frequency1
  }
  set frequency1(frequency1) {
    this._data.frequency1 = frequency1 || false
  }
  get frequency2() {
    return this._data.frequency2
  }
  set frequency2(frequency2) {
    this._data.frequency2 = frequency2 || false
  }
  get frequency3() {
    return this._data.frequency3
  }
  set frequency3(frequency3) {
    this._data.frequency3 = frequency3 || false
  }
  get frequency4() {
    return this._data.frequency4
  }
  set frequency4(frequency4) {
    this._data.frequency4 = frequency4 || false
  }
  get frequency5() {
    return this._data.frequency5
  }
  set frequency5(frequency5) {
    this._data.frequency5 = frequency5 || false
  }
  get frequency6() {
    return this._data.frequency6
  }
  set frequency6(frequency6) {
    this._data.frequency6 = frequency6 || false
  }
  get frequency7() {
    return this._data.frequency7
  }
  set frequency7(frequency7) {
    this._data.frequency7 = frequency7 || false
  }
  get days() {
    return this._data.days
  }
  set days(days) {
    this._data.days = days
  }
  get currency() {
    return this._data.currency
  }
  set currency(currency) {
    this._data.currency = currency
  }
  get beginDate() {
    return this._data.beginDate
  }
  set beginDate(beginDate) {
    this._data.beginDate = beginDate
  }
  get endDate() {
    return this._data.endDate
  }
  set endDate(endDate) {
    this._data.endDate = endDate
  }
  get remarks() {
    return this._data.remarks
  }
  set remarks(remarks) {
    this._data.remarks = remarks
  }
  get bookingAgent() {
    return this._data.bookingAgent
  }
  set bookingAgent(bookingAgent) {
    this._data.bookingAgent = bookingAgent || 0
  }
  get quotationUuid() {
    return this._data.quotationUuid
  }
  set quotationUuid(quotationUuid) {
    this._data.quotationUuid = quotationUuid
  }
}
